import React, { useEffect, useState } from "react";
import Main from "../../../../layout/main/Main";
import { Link, useSearchParams } from "react-router-dom";
import {
	ButtonContainer,
	ChildrenContainer,
	AntdButton,
	PageContainer,
	PageHeaderBlock,
	TitleBlock,
	PageTitle,
	PageSub,
	ContentShell,
} from "./styles";
import { get_clients_name_list } from "../../../../../api/endpoints/clients";
import AsignMenu from "./asign-menu/AsignMenu";
import { CONSTANTS } from "../../../../../utils/constants";

export default function AsignPage() {
	const [searchParams] = useSearchParams();
	const uri = searchParams.get("uri");

	const [filter, setFilter] = useState(
		CONSTANTS.DISTRIBUTORS_FILTER_WITHOUTCONTRACT,
	);
	const [laboratoriesWithContract, setLaboratoriesWithContract] =
		useState(null);
	const [laboratoriesWithoutContract, setLaboratoriesWithoutContract] =
		useState(null);
	const [selectedClient, setSelectedClient] = useState(null);

	const get_filter = () => {
		setFilter(
			localStorage.getItem("asignDistributorsIndexFilter")
				? localStorage.getItem("asignDistributorsIndexFilter")
				: CONSTANTS.DISTRIBUTORS_FILTER_WITHOUTCONTRACT,
		);
	};

	useEffect(() => {
		get_filter();
	}, []);

	useEffect(() => {
		const fetch_market_client_list = async () => {
			const res = await get_clients_name_list();
			setLaboratoriesWithoutContract(
				res
					?.filter((c) => c.isSeller)
					?.map((r) => ({
						value: r.id,
						label: r.name,
						isApproved: r.isApproved,
					}))
					.filter((l) => !l.isApproved),
			);
			setLaboratoriesWithContract(
				res
					?.filter((c) => c.isSeller)
					?.map((r) => ({
						value: r.id,
						label: r.name,
						isApproved: r.isApproved,
					}))
					.filter((l) => l.isApproved),
			);
		};

		fetch_market_client_list();
	}, []);

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						<Link to={"/admin/distributors?uri=" + uri}>Droguerías</Link>
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>
						Asignar droguerías
					</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>

			<Main.Body>
				<PageContainer>
					<PageHeaderBlock>
						<TitleBlock>
							<PageTitle>
								{filter === CONSTANTS.DISTRIBUTORS_FILTER_WITHOUTCONTRACT
									? `Relaciones clientes sin contrato`
									: "Relaciones cliente con contrato"}
							</PageTitle>
							<PageSub>
								Gestioná relaciones de las droguerias con los distintos clientes
							</PageSub>
						</TitleBlock>

						<ButtonContainer>
							<AntdButton
								$active={
									filter === CONSTANTS.DISTRIBUTORS_FILTER_WITHOUTCONTRACT
								}
								onClick={() =>
									setFilter(CONSTANTS.DISTRIBUTORS_FILTER_WITHOUTCONTRACT)
								}
							>
								Clientes sin contrato
							</AntdButton>

							<AntdButton
								$active={filter === CONSTANTS.DISTRIBUTORS_FILTER_WITHCONTRACT}
								onClick={() =>
									setFilter(CONSTANTS.DISTRIBUTORS_FILTER_WITHCONTRACT)
								}
							>
								Clientes con contrato
							</AntdButton>
						</ButtonContainer>
					</PageHeaderBlock>

					<ContentShell>
						<ChildrenContainer>
							{filter === CONSTANTS.DISTRIBUTORS_FILTER_WITHOUTCONTRACT &&
								laboratoriesWithContract && (
									<AsignMenu
										clients={laboratoriesWithoutContract}
										selectedClient={selectedClient}
										setSelectedClient={setSelectedClient}
										clientType={filter}
									/>
								)}
							{filter === CONSTANTS.DISTRIBUTORS_FILTER_WITHCONTRACT &&
								laboratoriesWithoutContract && (
									<AsignMenu
										clients={laboratoriesWithContract}
										selectedClient={selectedClient}
										setSelectedClient={setSelectedClient}
										clientType={filter}
									/>
								)}
						</ChildrenContainer>
					</ContentShell>
				</PageContainer>
			</Main.Body>
		</Main>
	);
}
